import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';

declare const google: any;

@Component({
  selector: 'app-map-controls',
  templateUrl: './map-controls.component.html',
  styleUrls: ['./map-controls.component.scss']
})
export class MapControlsComponent implements OnInit {

  @Input() map: any;
  @Input() trafficControl: boolean;
  @Input() focusControl: boolean;

  @Output() focusCallback = new EventEmitter();

  private trafficLayer: any;
  private showTrafficLayer: boolean;

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    this.trafficLayer = new google.maps.TrafficLayer();
    const zoomInButton = this.elementRef.nativeElement.getElementsByClassName('zoom-in')[0];
    const zoomOutButton = this.elementRef.nativeElement.getElementsByClassName('zoom-out')[0];
    google.maps.event.addDomListener(zoomInButton, 'click', () => {
      this.map.setZoom(this.map.getZoom() + 1);
    });
    google.maps.event.addDomListener(zoomOutButton, 'click', () => {
      this.map.setZoom(this.map.getZoom() - 1);
    });
  }

  toggleTrafficLayer() {
    this.showTrafficLayer = !this.showTrafficLayer;
    this.trafficLayer.setMap(this.showTrafficLayer ? this.map : null);
  }

  focusMap() {
    this.focusCallback.emit();
  }

}
